import { IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { ScreeningRecord, ScreeningResultsOrStatus } from "../types";

export const screeningStatusToIconMap = {
  NotScreened: {
    text: "Not Screened",
    icon: "circle" as IconType,
    color: Colors.Neutral600,
  },
  ReviewNeeded: {
    text: "Review Needed",
    icon: "user-magnifying-glass" as IconType,
    color: Colors.Neutral800,
  },
  GatheringInformation: {
    text: "Gathering Information",
    icon: "sync-alt" as IconType,
    color: Colors.Neutral600,
  },
  Complete: {
    text: "Complete",
    icon: "check" as IconType,
    color: Colors.Success600,
  },
  InProgress: {
    text: "In-Progress",
    icon: "sync-alt" as IconType,
    color: Colors.Neutral600,
  },
};

export const screeningResultToIconMap = {
  NoMatches: {
    text: "No matches found",
    icon: "check" as IconType,
    color: Colors.Success600,
  },
  PotentialMatches: {
    text: "Potential match",
    icon: "exclamation-triangle" as IconType,
    color: Colors.Warning600,
  },
  FalsePositive: {
    text: "False positive",
    icon: "check" as IconType,
    color: Colors.Success600,
  },
  TrueMatch: {
    text: "True match detected",
    icon: "exclamation-circle" as IconType,
    color: Colors.Danger600,
  },
  NoResult: { text: "", icon: "" as IconType, color: Colors.Neutral600 },
};

export const parseScreeningRecord = (
  screeningRecord: ScreeningRecord | null | undefined,
  type: ScreeningResultsOrStatus,
): {
  text: string;
  icon: IconType;
  color: Colors;
} => {
  if (type === "ScreeningStatus") {
    if (screeningRecord === null || screeningRecord === undefined) {
      return screeningStatusToIconMap["NotScreened"];
    } else {
      return screeningStatusToIconMap[screeningRecord.status];
    }
  } else if (type === "ScreeningResult") {
    return screeningResultToIconMap[screeningRecord?.result || "NoResult"];
  } else {
    return screeningResultToIconMap["NoResult"];
  }
};
